import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "15.6",
      fill: "#fff",
      stroke: "#CBCBCB",
      "stroke-width": ".8"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M16 18.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M7.667 16.733v-1.467c0-.867.708-1.583 1.583-1.583 1.509 0 2.125-1.067 1.367-2.375A1.583 1.583 0 0 1 11.2 9.15l1.442-.825c.658-.392 1.508-.159 1.9.5l.092.158c.75 1.308 1.983 1.308 2.741 0l.092-.158c.392-.659 1.242-.892 1.9-.5l1.442.825a1.583 1.583 0 0 1 .583 2.158c-.758 1.308-.142 2.375 1.367 2.375.866 0 1.583.708 1.583 1.583v1.467c0 .866-.708 1.583-1.583 1.583-1.509 0-2.125 1.067-1.367 2.375a1.58 1.58 0 0 1-.583 2.159l-1.442.824c-.658.392-1.508.159-1.9-.5l-.092-.158c-.75-1.308-1.983-1.308-2.741 0l-.092.159c-.392.658-1.242.891-1.9.5l-1.442-.826a1.583 1.583 0 0 1-.583-2.158c.758-1.308.142-2.375-1.367-2.375a1.59 1.59 0 0 1-1.583-1.583"
    }, null, -1)
  ]))]))
}
export default { render: render }